import { environment } from '../../../environments/environment';
import { AuthConfig } from 'angular-oauth2-oidc';
export const authConfig: AuthConfig = {
  issuer: environment.AUTH_PATH, 
  clientId: 'Web.Admin', // The "Auth Code + PKCE" client
  responseType: 'code',
  dummyClientSecret: 'bf8cf532-f0af-467e-9e9d-5fd2e8a9dc9f',
  redirectUri: window.location.origin + '/signin-oidc',
  postLogoutRedirectUri: window.location.origin + '/signout-callback-oidc',
  silentRefreshRedirectUri: window.location.origin + '/',
  scope:'openid profile offline_access connect_user_info service.product api.admin service.importer service.company service.channel service.mastercatalog service.notification service.media service.reports agent.rag agent.productEnrichment agent.language agent.digitalization service.b2b agent.alignment',
  useSilentRefresh: false, // Needed for Code Flow to suggest using iframe-based refreshes
  silentRefreshTimeout: 10000,
  timeoutFactor: 0.9, 
  sessionChecksEnabled: true,
  showDebugInformation: false, // Also requires enabling "Verbose" level in devtools
  clearHashAfterLogin: false, // https://github.com/manfredsteyer/angular-oauth2-oidc/issues/457#issuecomment-431807040,
  nonceStateSeparator: 'semicolon', // Real semicolon gets mangled by Duende ID Server's URI encoding 
};
